module.exports = __webpack_public_path__ + "static/img/20.30f8231.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/20.png
// module id = wrvb
// module chunks = 0